import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Transition } from '@headlessui/react';
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon, InformationCircleIcon, XMarkIcon, } from '@heroicons/react/24/outline';
export const Snackbar = ({ open, message, duration = 3000, position, severity, onClose }) => {
    const positionClasses = `fixed ${position.vertical === 'top' ? 'top-5' : 'bottom-5'} ${position.horizontal === 'center' ? 'left-1/2 transform -translate-x-1/2' : position.horizontal === 'right' ? 'right-5' : 'left-5'}`;
    useEffect(() => {
        let timer;
        if (open && duration) {
            timer = setTimeout(() => {
                onClose();
            }, duration);
        }
        return () => {
            clearTimeout(timer); // Clear the timer when the component unmounts or if the Snackbar is closed early
        };
    }, [open, duration, onClose]);
    const getColor = () => {
        switch (severity) {
            case 'error':
                return 'bg-red-700';
            case 'warning':
                return 'bg-orange-600';
            case 'info':
                return 'bg-blue-700';
            case 'success':
            default:
                return 'bg-green-700';
        }
    };
    const getIcon = () => {
        switch (severity) {
            case 'error':
                return _jsx(ExclamationCircleIcon, { className: "size-6" });
            case 'warning':
                return _jsx(ExclamationTriangleIcon, { className: "size-6" });
            case 'info':
                return _jsx(InformationCircleIcon, { className: "size-6" });
            case 'success':
            default:
                return _jsx(CheckCircleIcon, { className: "size-6" });
        }
    };
    return (_jsx(Transition, { show: open, enter: "transition-opacity duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "transition-opacity duration-300", leaveFrom: "opacity-100", leaveTo: "opacity-0", children: _jsxs("div", { className: `${positionClasses} ${getColor()} shadow-dark z-[500] flex items-center justify-between gap-1 rounded py-1.5 pl-4 pr-1 text-sm text-white`, children: [_jsx("div", { children: getIcon() }), _jsx("div", { className: "ml-1 py-2", children: message }), _jsx("button", { type: "button", onClick: onClose, className: "btn-icon hover:bg-transparent", children: _jsx(XMarkIcon, { className: "size-5" }) })] }) }));
};
//# sourceMappingURL=Snackbar.js.map